

    <div class="my-0 alert alert-light" role="alert">
        <div class="row p-3">
            <div class="p-0 mx-3 align-self-center">
                <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
            </div>
            <div class="col-11 p-0 m-0 align-self-center">
                <p class="m-0">
                    <strong>Por que solicitamos a chave PIX da empresa?</strong>
                    <br>Em eventuais estornos ou devoluções de recursos da Bankei Beneflex para a empresa, será utilizada a chave PIX.
                    <br>Obrigatoraimente, a chave PIX deve ser de titularidade da empresa.
                </p>
            </div>
        </div>
    </div>

<div class="container-fluid card-pix">

    <div class="row p-b-5 col-10">
        <div class="col-12 text-center p-0 mt-5">
          <h4 class="p-2 text-white header-pix" [style.backgroundColor]="'#111224'">Informe a chave PIX da sua empresa</h4>
        </div>
        
        <div *ngIf="this.chavePix" class="col-12 body-pix" [style.backgroundColor]="'#ffffff'" >
          <div class="row text-center">
            <div [ngSwitch]="tipoChavePix" class="col mt-3">
              <span *ngSwitchCase="1" [textMask]="{mask: cpfMask}" class="chave-pix"><b>Chave:</b> {{chavePix | cpf}}</span>
              <span *ngSwitchCase="2" [textMask]="{mask: cnpjMask}" class="chave-pix"><b>Chave:</b> {{chavePix | cnpj}}</span>
              <span *ngSwitchCase="3" [textMask]="{mask: celularMask}" class="chave-pix"><b>Chave:</b> {{chavePix | telefone}}</span>
              <span *ngSwitchDefault class="chave-pix"><b>Chave:</b> {{chavePix}}</span>
            </div>
          </div>
          <div class="botoes-pix text-center">
            
            <button (click)="editarChavePix()" class="custom-filter-button mr-2">Editar chave</button>
            <button class="custom-filter-button button-cancel" (click)="excluirChavePix()">Excluir chave</button>
          </div>
        </div>
        <div *ngIf="this.loading" class="col-12" [style.backgroundColor]="'#ffffff'">
            <div class="row text-center">
                <div class="col loading">
                <span>Carregando...</span>
                </div>
            </div>
        </div>
        <div *ngIf="!this.chavePix && !this.loading" class="col-12 body-pix" [style.backgroundColor]="'#ffffff'">
          <div class="row text-center">
            <div class="col chave-pix-nao-registrada">
              <span>Você não possui uma chave pix registrada. Para cadastrar uma clique no botão a baixo.</span>
            </div>
          </div>
          <div class="botoes-pix text-center">
            <button (click)="create()" class="btn btn-cadastrar">Cadastrar chave pix</button>
          </div>
        </div>
      </div>
    <!--opções listagem-->
    <!-- <div class="row container-fluid mt-5 mb-4 mx-auto p-0">
        <div class="col-12">
            <div class="row h-100">
                <div (click)="selectAllToDelete(selectAll = !selectAll);" class="list-select-all mr-4 my-1"
                    [ngClass]="{'active': deleteCount > 0}"><img
                        [src]="(deleteCount > 0) ? '/assets/icons/check-purple.png':'/assets/icons/check-grey.png'"
                        width="auto" height="20px" /> <span class="mx-2">Selecionar tudo</span></div>
                <div *ngIf="deleteCount > 0" (click)="showDeleteAll(deleteallmodal);" class="list-delete mr-4 my-1"
                    [ngClass]="{'active': deleteCount > 0}"><img
                        [src]="(deleteCount > 0) ? '/assets/icons/garbage-purple.png':'/assets/icons/garbage-grey.png'"
                        width="auto" height="20px" /> <span class="mx-2">Excluir</span></div>
                <div class="mr-4 my-1"><button type="button" class="list-header-filter-button"
                        (click)="showFilter(filtro)"><img class="list-header-icon-filter"
                            src="./assets/icons/filter-tool.png" /> Aplicar filtro</button></div>
                <div class="mr-4 my-1"><input class="list-header-search-input w-100" type="search"
                        placeholder="Pesquise aqui..." #search (input)="searchFilter(search.value)" /></div>
                <div class="list-show-item ml-auto">Mostrar:
                    <select [(ngModel)]="showItem">
                        <option [ngValue]="10" value="10" selected>10</option>
                        <option [ngValue]="25" value="25">25</option>
                        <option [ngValue]="50" value="50">50</option>
                        <option [ngValue]=100 value="100">100</option>
                    </select>
                </div>
                <div class="list-pagination ml-auto">
                    <pagination-controls (pageChange)="currentPage = $event" responsive="true" previousLabel=""
                        nextLabel=""></pagination-controls>
                </div>
            </div>
        </div>
    </div>



    <div class="list-box">
        <table class="list-table table table-striped">
            <thead class="list-table-head">
                <th></th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('bancoNome', sortOrder)">Banco</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('agencia', sortOrder)">Agência</th>
                <th class="" (click)="sortOrder = !sortOrder; orderBy('conta', sortOrder)">Conta</th>
                <th></th>
                <th></th>
            </thead>
            <tbody class="list-table-row">
                <tr *ngFor="let item of dadosBancariosList | paginate: { itemsPerPage: showItem, currentPage: currentPage }"
                    class=" list-table-cell">
                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        <span class="mx-2">
                            <input [attr.id]="item.unidadeId" type="checkbox" class="radio-checkbox"
                                [(ngModel)]="item.toDelete" />
                            <label [attr.for]="item.unidadeId" class="radio-label"></label>
                        </span>
                    </td>

                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{item.bancoNome}}</td>

                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{item.agencia}}<span *ngIf="item.digitoAgencia">-</span>{{item.digitoAgencia}}</td>

                    <td class="clickable" (click)="item.toDelete = !item.toDelete; updateDeleteCount();">
                        {{item.conta}}<span *ngIf="item.digitoConta">-</span>{{item.digitoConta}}</td>

                    <td>
                        <span *ngIf="item.preferencial">Preferencial</span>
                    </td>

                    <td>
                        <div ngbDropdown class="d-inline-block menu-option">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img
                                    src="assets/icons/menu.png" /></button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div ngbDropdownItem (click)="edit(item)"><img src="assets/icons/pencil-purple.png"
                                            class="mr-2" />Editar</div>

                                    <div ngbDropdownItem (click)="showDelete(deletemodal,item);"
                                        *ngIf="!item.preferencial">
                                        <img src="assets/icons/garbage-purple.png" class="mr-2" />Excluir</div>

                                </section>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!(dadosBancariosList?.length > 0)" class="text-center my-2">
            Não há registros de dados bancários
        </div>
    </div> -->
</div>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="container custom-filter">
        <div class="row mx-5">
            <div class="col-12 custom-filter-title my-5">Aplicar filtro</div>
            <div class="col-lg-12 col-md-12 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input #filtrobanco class="custom-filter-input" type="text" [(ngModel)]="filtroBanco" />
                    <label class="custom-filter-label" for="filtrobanco">Banco:</label>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input #filtroagencia class="custom-filter-input" type="text" [(ngModel)]="filtroAgencia" />
                    <label class="custom-filter-label" for="filtroagencia">Agência:</label>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input #filtroconta class="custom-filter-input" type="text" [(ngModel)]="filtroConta" />
                    <label class="custom-filter-label" for="filtroconta">Conta:</label>
                </div>
            </div>
            <div class="col-12 text-center my-5"><button class="custom-filter-button" type="button"
                    (click)="applyFilter(filtrobanco.value,filtroagencia.value,filtroconta.value);modal.dismiss('Close click')">APLICAR</button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal do Deletar-->
<ng-template #deletemodal let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>Tem certeza que deseja excluir a <br> o dado bancário:
                    <br>Banco: {{dadoBancarioToDelete.bancoNome}}
                    <br>Agência: {{dadoBancarioToDelete.agencia}}<span
                        *ngIf="dadoBancarioToDelete.digitoAgencia">-</span>{{dadoBancarioToDelete.digitoAgencia}}
                    <br>Conta: {{dadoBancarioToDelete.conta}}<span
                        *ngIf="dadoBancarioToDelete.digitoConta">-</span>{{dadoBancarioToDelete.digitoConta}}
                    ?</p>
            </div>
            <div class="col-12 text-center my-2"><button class="custom-modal-button" type="button"
                    (click)="delete(dadoBancarioToDelete);modal.dismiss('Close click')">EXCLUIR</button></div>
            <div class="col-12 text-center mt-2 mb-5"><button class="custom-modal-button-text" type="button"
                    (click)="modal.dismiss('Close click')">CANCELAR</button></div>
        </div>
    </div>
</ng-template>

<!--Modal do Deletar Vários-->
<ng-template #deleteallmodal let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>Tem certeza que deseja excluir {{deleteCount}} dado(s) bancário(s)?</p>
            </div>
            <div class="col-12 text-center my-2"><button class="custom-modal-button" type="button"
                    [disabled]="deleteCount < 1"
                    (click)="deleteAllSelected();modal.dismiss('Close click')">EXCLUIR</button></div>
            <div class="col-12 text-center mt-2 mb-5"><button class="custom-modal-button-text" type="button"
                    (click)="modal.dismiss('Close click')">CANCELAR</button></div>
        </div>
    </div>
</ng-template>
